import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import router from '@/router'

export default async function () {
  const formStore = useFormStore()

  try {
    const res = await apiHelperService.post('/api/icaRequest/draft/submitCitizenApplication', {
      serviceTransactionId: router.currentRoute.value.params.serviceId,
      requestNumber: formStore.draft?.requestNumber,
      administrativeRegionId: router.currentRoute.value.query.administrativeRegionId,
      request: formStore.draft.request
    })
    return true
  } catch (error) {
    console.error('Error submitting application: user561PreReview', error)
  }
}
